import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getRoot, $insertNodes, $setSelection } from 'lexical';
import { $generateNodesFromDOM } from '@lexical/html';
import trimUnsizedTrailingCols from '@/components/LexicalEditor/utils/trimUnsizedTrailingCols';

const LoadInitialContent = ({
  initialContent,
}: {
  initialContent?: string;
}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!initialContent) {
      return;
    }
    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(initialContent, 'text/html');
      trimUnsizedTrailingCols(dom);
      const nodes = $generateNodesFromDOM(editor, dom);
      $getRoot().clear();
      $insertNodes(nodes);
      // 삽입 끝 커서가 남으면 에디터가 포커스되며 본문 끝까지 스크롤
      $setSelection(null);
    });
  }, []);

  return null;
};

export default LoadInitialContent;
